import { tickersNames } from 'common/constants';

interface SelectTickersProps {
  selectedTicker: DefaultTicker[];
  setSelectedTicker: (value: DefaultTicker[]) => void;
}

function SelectTickers({
  selectedTicker,
  setSelectedTicker,
}: SelectTickersProps) {
  const tickersNamesPM: DefaultTicker[] = ['AU', 'AG', 'PT', 'PD', 'RH', 'GSR'];
  const tickersNamesBM: DefaultTicker[] = ['CU', 'NI', 'AL', 'PB', 'ZN'];
  const tickersNamesOi: DefaultTicker[] = ['CL', 'UR'];
  const tickersNamesCryptoFirst: DefaultTicker[] = [
    'BTC',
    'ETH',
    'XRP',
    'USDT',
    'SOL',
  ];
  const tickersNamesCryptoSecond: DefaultTicker[] = [
    'BNB',
    'DOGE',
    'ADA',
    'TRX',
    'LINK',
  ];

  return (
    <div className='flex lg:flex-col space-y-2 w-2/3 lg:w-auto'>
      <div className='flex lg:space-x-2 flex-col lg:flex-row'>
        <div>
          {tickersNamesPM.map((ticker) => (
            <TickerItem
              key={ticker}
              ticker={ticker}
              selectedTicker={selectedTicker}
              setSelectedTicker={setSelectedTicker}
            />
          ))}
        </div>
        <div className='h-[115px] bg-gray-300 w-[1px] hidden lg:block'></div>
        <div>
          {tickersNamesBM.map((ticker) => (
            <TickerItem
              key={ticker}
              ticker={ticker}
              selectedTicker={selectedTicker}
              setSelectedTicker={setSelectedTicker}
            />
          ))}
        </div>
        <div className='h-[115px] bg-gray-300 w-[1px] hidden lg:block'></div>
        <div>
          {tickersNamesOi.map((ticker) => (
            <TickerItem
              key={ticker}
              ticker={ticker}
              selectedTicker={selectedTicker}
              setSelectedTicker={setSelectedTicker}
            />
          ))}
        </div>
        <div className='h-[115px] bg-gray-300 w-[1px] hidden lg:block'></div>
        <div className='hidden lg:block'>
          {tickersNamesCryptoFirst.map((ticker) => (
            <TickerItem
              key={ticker}
              ticker={ticker}
              selectedTicker={selectedTicker}
              setSelectedTicker={setSelectedTicker}
            />
          ))}
        </div>
        <div className='hidden lg:block'>
          {tickersNamesCryptoSecond.map((ticker) => (
            <TickerItem
              key={ticker}
              ticker={ticker}
              selectedTicker={selectedTicker}
              setSelectedTicker={setSelectedTicker}
            />
          ))}
        </div>


      </div>
      <div className='lg:hidden'>
          {[...tickersNamesCryptoFirst, ...tickersNamesCryptoSecond].map((ticker) => (
            <TickerItem
              key={ticker}
              ticker={ticker}
              selectedTicker={selectedTicker}
              setSelectedTicker={setSelectedTicker}
            />
          ))}
        </div>
    </div>
  );
}

interface TickerItemProps {
  ticker: DefaultTicker;
  selectedTicker: DefaultTicker[];
  setSelectedTicker: (value: DefaultTicker[]) => void;
}
const TickerItem = ({
  ticker,
  selectedTicker,
  setSelectedTicker,
}: TickerItemProps) => {
  return (
    <div className='flex items-center'>
      <label className='text-[12px] lg:text-[13px] flex items-center'>
        <input
          disabled={
            selectedTicker.includes(ticker) && selectedTicker.length <= 2
          }
          type='checkbox'
          value={ticker}
          checked={selectedTicker.includes(ticker)}
          onChange={(e) => {
            if (e.target.checked) {
              setSelectedTicker([...selectedTicker, ticker]);
            } else {
              setSelectedTicker(
                selectedTicker.filter((item) => item !== ticker)
              );
            }
          }}
          className='mx-1 h-[15px] w-[15px] cursor-pointer'
        />
        {tickersNames[ticker]}
      </label>
    </div>
  );
};

export default SelectTickers;
